import LanguagePack from "../../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import PdfHorizontalLineContent from "../../../../../../lib/html5-software-library/src/ranj/pdf/content/generic/PdfHorizontalLineContent";
import PdfImageContent from "../../../../../../lib/html5-software-library/src/ranj/pdf/content/generic/PdfImageContent";
import PdfSpacingContent from "../../../../../../lib/html5-software-library/src/ranj/pdf/content/generic/PdfSpacingContent";
import AbstractPdfSection from "../../../../../../lib/html5-software-library/src/ranj/pdf/sections/AbstractPdfSection";
import PersonalReportConfig from "../../model/PersonalReportConfig";

export default class HeaderSection extends AbstractPdfSection {
    /**
     * @constructor
     * @param {PersonalReportConfig} pdfConfig 
     * @param {LanguagePack} languagePack
     */
    constructor(pdfConfig, languagePack) {
        super(pdfConfig.pageWidth);

        this._pdfConfig = pdfConfig;
        this._languagePack = languagePack;
    }

    async loadData() {

    }

    initialize() {
        super.initialize();

        const banner = new PdfImageContent(this._pdfConfig, this._pdfConfig.getValue("elements.general.banner"))
        this.addContent(banner);

        this.addContent(new PdfSpacingContent(0, -5));

        const headerTitle = this._languagePack.getText('personalReport.header.title');
        this.addText(headerTitle, this._pdfConfig.getValue("elements.cover.titleText"));

        this.addPageBreak(false);
    }
}